$(document).ready(function() {
  $('#user_nationality').on('change', function() {
    if($(this).val() === 'FR') {
      $('#kycDisclaimerForUS, #kycDisclaimerForOther').addClass('hidden');
      $('#kycDisclaimerForFR').removeClass('hidden');
    }
    else if(['CA', 'US'].includes($(this).val())) {
      $('#kycDisclaimerForFR, #kycDisclaimerForOther').addClass('hidden');
      $('#kycDisclaimerForUS').removeClass('hidden');
    }
    else {
      $('#kycDisclaimerForFR, #kycDisclaimerForUS').addClass('hidden');
      $('#kycDisclaimerForOther').removeClass('hidden');
    }
  });
})
